import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import ProgressTracker from './ProgressTracker';
import BulletCard from './BulletCard';

/**
 * Bullets panel showing generated bullets with scores
 * 
 * Features:
 * - Progress tracker at top
 * - Scrollable bullet list
 * - Individual save buttons on each bullet
 */
const BulletsPanel = ({ bullets, progress, onSaveBullet }) => {

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#fafbfc'
      }}
    >
      {/* Header */}
      <Box
        sx={{
          p: 3,
          borderBottom: '1px solid #e5e7eb',
          bgcolor: 'white',
          flexShrink: 0
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#111827', display: 'flex', alignItems: 'center', gap: 1 }}>
          ✨ Generated Bullets
        </Typography>
        <Typography variant="caption" sx={{ color: '#6b7280' }}>
          Three variations from your conversation
        </Typography>
      </Box>

      {/* Progress Tracker */}
      <Box sx={{ p: 3, bgcolor: 'white', borderBottom: '1px solid #e5e7eb', flexShrink: 0 }}>
        <ProgressTracker current={progress.current} target={progress.target} />
      </Box>

      {/* Bullets */}
      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
          p: 3
        }}
      >
        {bullets.length === 0 ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              color: '#9ca3af'
            }}
          >
            <Typography variant="body1" sx={{ mb: 1 }}>
              No bullets yet
            </Typography>
            <Typography variant="caption">
              Start the conversation to generate bullets
            </Typography>
          </Box>
        ) : (
          <Stack spacing={3}>
            {bullets.map((bullet) => (
              <BulletCard key={bullet.id} bullet={bullet} onSave={onSaveBullet} />
            ))}
          </Stack>
        )}
      </Box>


    </Box>
  );
};

export default BulletsPanel;
